<!-- ----------------------------------------------- -->
<template>
  <div :class="popupStyle" :style="contentStyle">
    <v-card
      :class="popupContentStyle"
      class="grey--text text--darken-2"
      :elevation="isPcMode ? 2 : 0"
      :style="popupOpacity"
    >
      <div v-if="isPcMode" :class="popupMessageStyle">
        {{ messageConfig.pastMode }}
        <v-btn
          :color="popupColor"
          class="pa-0"
          :disabled="disableUpdate"
          icon
          @click="renew"
          ><v-icon>update</v-icon>
        </v-btn>
      </div>
      <div v-else :class="popupMessageStyle">
        {{ messageConfig.mbPastMode1 }}
        <br />
        {{ messageConfig.mbPastMode2 }}
        <v-btn
          :color="popupColor"
          class="pa-0"
          :disabled="disableUpdate"
          icon
          small
          @click="renew"
          ><v-icon>update</v-icon>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 過去表示中ポップアップ
 * PastPopup.vue
 * @author LIS
 */
import PageLog from "../../lib/pageLog.js";

export default {
  name: "map-past-popup",
  data() {
    return {
      /** 文字列リソース */
      text: {
        mbPastMode: "過去",
        mbPastMode2: "表示中",
      },
    };
  },
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** メッセージ情報 */
    messageConfig: {
      get() {
        return this.$store.state.app.config.messageConfig;
      },
    },
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** 緊急・任意お知らせの数を取得 */
    infoCount: {
      get() {
        let cnt = 0;
        if (this.$store.state.info.emergency) {
          cnt += this.$store.state.info.emergency.length;
        }
        if (this.$store.state.info.any) {
          cnt += this.$store.state.info.any.length;
        }
        return cnt;
      },
    },
    /** 表示位置調整 */
    contentStyle: {
      get() {
        // PCモードの場合はお知らせ件数によって表示位置を調整する
        // MBモードの場合は表示場所がMapHeader上なのでお知らせは考慮しない
        if (this.isPcMode) {
          // お知らせの領域1つあたりの高さ
          const infoHeight = 30;
          // 表示位置調整
          const topValue = infoHeight * this.infoCount;
          return "margin-top: " + String(topValue) + "px;";
        } else {
          return "margin-top: 0px;";
        }

      },
    },
    /** モードによってポップアップのスタイルを切り替える */
    popupStyle() {
      if (this.isPcMode) {
        return "pc-popup";
      } else {
        return "mb-popup";
      }
    },
    /** モードによってポップアップコンテンツのスタイルを切り替える */
    popupContentStyle() {
      if (this.isPcMode) {
        return "pc-popup-content";
      } else {
        return "mb-popup-content";
      }
    },
    /** モードによってポップアップメッセージのスタイルを切り替える */
    popupMessageStyle() {
      if (this.isPcMode) {
        return "pc-popup-message";
      } else {
        return "mb-popup-message";
      }
    },
    /** モードによってポップアップメッセージの色を切り替える */
    popupColor() {
      if (this.isPcMode) {
        return "grey darken-2"
      } else {
        return "brown"
      }
    },
    /** ポップアップの透過度 */
    popupOpacity() {
      return "opacity: " + this.mapConfig.pastPopup.opacity;
    },
    /** 更新ボタンの活性/非活性を制御する */
    disableUpdate: {
      get() {
        // 履歴動画再生状態による制御
        if (!this.$store.getters["radar/isNotPlay"]) {
          return true;
        }

        // 表示コンテンツによる制御
        const content = this.$store.state.app.content;
        if (
          content == "Inundation" ||
          content == "VcPoint" ||
          content == "VcDefault" ||
          content == "VcCustom"
        ) {
          return true;
        }
        return false;
      },
    },
  },
  methods: {
    /** 観測日時更新 */
    renew() {
      // アクセスログ出力
      PageLog.log({
        page_log: "map",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      // レーダの履歴動画再生状態をリセット
      this.$store.commit("radar/resetHistoryPlay");
      // ストアの観測日時更新
      this.$store.commit("app/renewTime");
      // 画面遷移時の保持日時を更新
      this.$store.commit("app/setRetentionTime", {
        flag: true,
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/_media_query.scss";
@import "./../../scss/color.scss";
.pc-popup {
  z-index: 3020;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  display: flex;
  align-items: center;
  .pc-popup-content {
    max-width: 500px;
    margin: auto;
    background-color: $color-past-popup-back;
    .pc-popup-message {
      padding: 8px;
      font-size: 14px;
      color: $color-past-popup-text;
      display: flex;
      align-items: center;
    }
  }
}
// PC端末のMBモード
@include landscape {
  .mb-popup {
    z-index: 3020;
    display: flex;
    align-items: center;
    .mb-popup-content {
      max-width: 500px;
      margin: auto;
      background-color: $color-past-popup-back;
      .mb-popup-message {
        padding-left: 4px;
        font-size: 10px;
        line-height: 1.2;
        color: $color-mb-past-popup-text;
        display: flex;
        align-items: center;
      }
    }
  }
}
// MB端末表示
@include portrait {
  .mb-popup {
    z-index: 3020;
    display: flex;
    align-items: center;
    .mb-popup-content {
      max-width: 500px;
      margin: auto;
      background-color: $color-past-popup-back;
      .mb-popup-message {
        padding-left: 4px;
        font-size: 10px;
        line-height: 1.2;
        color: $color-mb-past-popup-text;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
